import { render } from "./BuildingWireframe.vue?vue&type=template&id=eafdfc48"
import script from "./BuildingWireframe.vue?vue&type=script&lang=js"
export * from "./BuildingWireframe.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__